import { color as d3Color } from 'd3-color';

function toRgbaWithOpacity(hexColor: string, opacity: number): string {
  const parsed = d3Color(hexColor);
  return parsed !== null
    ? parsed.copy({ opacity }).formatRgb()
    : `rgba(0,0,0,${opacity})`;
}

/**
 * Creates a horizontal linear `CanvasGradient` that transitions from
 * `sourceColor` at `sourceX` to `targetColor` at `targetX`, with each color
 * stop at the given `opacity`.
 */
export function buildLinkGradient(
  ctx: CanvasRenderingContext2D,
  sourceX: number,
  targetX: number,
  sourceColor: string,
  targetColor: string,
  opacity: number,
): CanvasGradient {
  const endX = sourceX === targetX ? targetX + 1 : targetX;
  const gradient = ctx.createLinearGradient(sourceX, 0, endX, 0);
  gradient.addColorStop(0, toRgbaWithOpacity(sourceColor, opacity));
  gradient.addColorStop(1, toRgbaWithOpacity(targetColor, opacity));
  return gradient;
}
